import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cargar, seguimiento } from "../carga";

export const fetchUsersList = createAsyncThunk(
    "rooms/fetchUsersList",
    async () => {
       return await cargar('users');
    }
);

export const UsersSlice = createSlice({
  name: "users",
  initialState: {
    usersList: [],
    listAux: [],
    loading: false,
    error: null,
  },
  reducers: {
/*       sort: (state, {payload}) => {
          switch (payload){
             case "new":
                state.listAux = state.listAux.sort((a, b) => {
                    let date1 = new Date(a.startDate)
                    let date2 = new Date(b.startDate)
                    return date1 - date2;
                })
                break;
             case "old":
                state.listAux = state.listAux.sort((a, b) => {
                    let date1 = new Date(a.startDate)
                    let date2 = new Date(b.startDate)
                    return date2 - date1;
                })
                break; 
             default:
                console.log("sort error")
          }
      }, */
      all: (state) => {
          state.listAux = state.usersList;
      },
/*       filter: (state, {payload}) => {
          state.listAux = state.usersList.filter(u => u.status === payload)
      } */
  },
  extraReducers: builder => {
    seguimiento(builder, fetchUsersList, (state, payload) => { state.listAux = payload; state.usersList = payload; });
  },
});

export const selector = (state) => state.users;

export const {all} = UsersSlice.actions;

export default UsersSlice.reducer;
